<dialog [id]="modalDialogId" class="modal">
    <div class="modal-box p-5 w-[600px] max-w-[800px] mobile:max-w-[90vw]">
        <!-- Header -->
        <div class="flex flex-wrap gap-2 justify-between items-center mobile:flex-col mobile:items-center">
            <div class="flex flex-col">
                <p class="font-bold text-3xl">{{ 'settings.invite_team_members' | transloco }}</p>
                <p class="text-neutral-1200">{{ 'settings.fill_in_staff_email' | transloco }}</p>
            </div>
            <button (click)="closeModal()"><img src="assets/icons/close-circle-black.svg" alt="X"></button>
        </div>

        <!-- Invite with email row -->
        <div class="mt-10 flex w-full gap-2 h-auto items-end mobile:flex-col mobile:items-center">
            <div class="flex-[2] mobile:w-full">
                <app-labeled-input labelText="{{ 'settings.label.invite_email' | transloco }}" [inputId]="'inviteEmail'"
                    [inputType]="'text'" [(inputValue)]="inviteEmailInput" [errorMessage]="inviteEmailInputError"
                    placeholder="{{ 'settings.placeholder.invite_email' | transloco }}"
                    boxHeight="h-[50px]"></app-labeled-input>
            </div>
            <div class="flex-[1] mobile:w-full">
                <div class="flex flex-col">
                    <app-custom-dropdown [options]="rolesOptions" [(selectedOption)]="selectedRole"
                        placeholder="{{ 'shared.select_role' | transloco }}">
                    </app-custom-dropdown>
                    <div *ngIf="selectRoleShowError" class="flex items-center text-error mt-2 text-sm">
                        <img src="assets/icons/close-circle.svg" alt="{{ 'shared.components.error_icon' | transloco }}"
                            class="w-5 h-5" />
                        <p class="ml-1">{{ 'shared.validators.role.required' | transloco }}</p>
                    </div>
                </div>
            </div>
            <div class="flex-[1] h-[50px] min-w-[100px] mobile:w-full">
                <app-custom-button buttonText="{{ 'settings.button.invite' | transloco }}" [isDisabled]="false"
                    backgroundColor="bg-primary" textColor="text-white" borderColor="border:bg-primary"
                    hoverBackgroundColor="hover:bg-primary-1200" leadingIcon="assets/icons/settings/mail.svg"
                    disabledBackgroundColor="bg-success" (buttonClick)="inviteUserButtonClick()"
                    [isDisabled]="userInvited">
                </app-custom-button>
            </div>
        </div>

        <p class="text-success mt-5" *ngIf="userInvited">{{ 'settings.invitation_sent' | transloco }}</p>
        <p class="text-error mt-5" *ngIf="showErrorMessage">{{ showErrorMessage }}</p>

        <!-- Separator -->
        <div class="h-[1px] w-full bg-border my-10"></div>

        <!-- Invite with link row -->
        <div class="flex w-full gap-2 h-auto items-end mobile:flex-col mobile:items-center">
            <div class="flex-[2] mobile:w-full">
                <app-labeled-input labelText="{{ 'settings.label.invite_link' | transloco }}" [inputId]="'inviteLink'"
                    [inputType]="'text'" [(inputValue)]="inviteLinkInput" [errorMessage]="inviteLinkInputError"
                    placeholder="{{ 'settings.placeholder.invite_link' | transloco }}" boxHeight="h-[50px]"
                    [isDisabled]="true"></app-labeled-input>
            </div>
            <div class="flex-[1] h-[50px] min-w-[160px] mobile:w-full">
                <app-custom-button buttonText="{{ 'settings.button.copy_invite_link' | transloco }}"
                    [isDisabled]="false" backgroundColor="bg-[#FFFFFF]" textColor="text-secondary"
                    borderColor="border-secondary" hoverBackgroundColor="hover:bg-secondary-500"
                    hoverBorderColor="hover:border-secondary-1200" leadingIcon="assets/icons/settings/link.svg"
                    (buttonClick)="copyInviteLink()">
                </app-custom-button>
            </div>

        </div>

        <p class="mt-2 text-neutral-1200 text-sm">{{ 'settings.access_link_info' | transloco }}</p>

    </div>
    <form method="dialog" class="modal-backdrop">
        <button>Close</button>
    </form>
</dialog>